import {
  AuthorizedUiElementService,
  AuthorizedUiElementConfig,
} from "../../../../../../../ui/authorizedUiElement";
import { vsServiceName as machineDetailTabsServiceName } from "./machineDetailTabsService";

export class MachineDetailTabsController {
  static $inject = [machineDetailTabsServiceName];
  constructor(
    private readonly machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}

  getTabs(): AuthorizedUiElementConfig[] {
    return this.machineDetailTabsService.getConfigs();
  }
}
